"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractStrategyConverter_1 = require("./AbstractStrategyConverter");
/**
 * MultiTargetStrategyConverter.
 *
 * @author RV
 */


var MultiTargetStrategyConverter =
/*#__PURE__*/
function (_AbstractStrategyConv) {
  _inherits(MultiTargetStrategyConverter, _AbstractStrategyConv);

  function MultiTargetStrategyConverter() {
    _classCallCheck(this, MultiTargetStrategyConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(MultiTargetStrategyConverter).apply(this, arguments));
  }

  return MultiTargetStrategyConverter;
}(AbstractStrategyConverter_1.AbstractStrategyConverter);

exports.MultiTargetStrategyConverter = MultiTargetStrategyConverter;